<template>
  <div class="manufacturer-business-area">
    <div class="box border-line-right">
      <div class="title-area">
        <div class="title">Üretici Bilgileri</div>
        <div class="description">
          Ürünün üreticisine ait bilgiler ve adres içerir.
        </div>
      </div>
      <div
        v-for="(manufacturer, index) in manufacturers"
        :key="`manufacturer-${index}`"
        class="box-form-area"
      >
        <button
          v-if="manufacturers.length > 1 && index > 0"
          @click="removeManufacturer(index)"
          class="remove-button"
          type="button"
        >
          <div class="remove-button-content">
            <Icons name="Delete" color="#5D3EBC" size="sm" />
            <span>Sil</span>
          </div>
        </button>
        <div class="input-wrapper">
          <Input
            label="Kayıtlı Ticari Ünvan"
            :id="`manufacturer-trade-name-${index}`"
            :isError="!!manufacturer.tradeNameError"
            v-model:value="manufacturer.tradeName"
          />
          <p v-if="manufacturer.tradeNameError" class="error-text">
            {{ manufacturer.tradeNameError }}
          </p>
        </div>
        <div class="input-wrapper">
          <Input
            label="Marka"
            :id="`manufacturer-brand-${index}`"
            :isError="!!manufacturer.brandError"
            v-model:value="manufacturer.brand"
          />
          <p v-if="manufacturer.brandError" class="error-text">
            {{ manufacturer.brandError }}
          </p>
        </div>
        <div class="textarea-wrapper">
          <Input
            type="textarea"
            label="İletişim Adresi"
            :id="`manufacturer-address-${index}`"
            :class="{ error: manufacturer.addressError }"
            v-model:value="manufacturer.address"
            :isError="!!manufacturer.addressError"
          />
          <p v-if="manufacturer.addressError" class="error-text">
            {{ manufacturer.addressError }}
          </p>
        </div>
        <div class="input-wrapper">
          <Input
            label="E-posta"
            :id="`manufacturer-email-${index}`"
            :isError="!!manufacturer.emailError"
            v-model:value="manufacturer.email"
          />
          <p v-if="manufacturer.emailError" class="error-text">
            {{ manufacturer.emailError }}
          </p>
        </div>
        <DropdownSelectable
          label="Menşei"
          :key="`manufacturer-origin-${index}-${manufacturer.origin}-${originOptionsVersion}`"
          :id="`manufacturer-origin-${index}`"
          :dropItems="manufacturerOrigins"
          :isRadioGroup="true"
          :isShowSearch="false"
          :preSelectedRadioItem="
            manufacturerOrigins.find((o) => String(o.id) === String(manufacturer.origin))
          "
          :errorText="manufacturer.originError"
          @selectedRadioItem="
            (value) => handleOriginChange(value, index, 'manufacturer')
          "
        />
      </div>
      <a
        v-if="manufacturers.length < 5"
        @click="addManufacturer"
        class="manufacturer-business-area-button"
      >
        <img src="@/assets/images/icons/plus-magenta.svg" />
        <p>Farklı Üretici Bilgisi Ekle</p>
      </a>
      <p v-else class="limit-text">
        En fazla 5 Üretici Bilgisi ekleyebilirsiniz.
      </p>
    </div>
    <div class="box">
      <div class="title-area">
        <div class="title">İthalatçı / İktisadi İşletmeci</div>
        <div class="description">
          Bir ürünün imalatçısı, yetkili temsilcisi, ithalatçısı, dağıtıcısı
          veya ürünün imalatına, piyasada bulundurulmasına veya hizmete
          sunulmasına ilişkin sorumluluğu olan diğer kişileri ifade eder.
        </div>
      </div>
      <div
        v-for="(importer, index) in importers"
        :key="`importer-${index}`"
        class="box-form-area"
      >
        <button
          v-if="importers.length > 1 && index > 0"
          @click="removeImporter(index)"
          class="remove-button"
          type="button"
        >
          <div class="remove-button-content">
            <Icons name="Delete" color="#FF44EE" size="sm" />
            <span>Sil</span>
          </div>
        </button>
        <div class="input-wrapper">
          <Input
            label="Kayıtlı Ticari Ünvan"
            :id="`importer-trade-name-${index}`"
            :isError="!!importer.tradeNameError"
            v-model:value="importer.tradeName"
          />
          <p v-if="importer.tradeNameError" class="error-text">
            {{ importer.tradeNameError }}
          </p>
        </div>
        <div class="input-wrapper">
          <Input
            label="Marka"
            :id="`importer-brand-${index}`"
            :isError="!!importer.brandError"
            v-model:value="importer.brand"
          />
          <p v-if="importer.brandError" class="error-text">
            {{ importer.brandError }}
          </p>
        </div>
        <div class="textarea-wrapper">
          <Input
            type="textarea"
            label="İletişim Adresi"
            :id="`importer-address-${index}`"
            :class="{ error: importer.addressError }"
            v-model:value="importer.address"
            :isError="!!importer.addressError"
          />
          <p v-if="importer.addressError" class="error-text">
            {{ importer.addressError }}
          </p>
        </div>
        <div class="input-wrapper">
          <Input
            label="E-posta"
            :id="`importer-email-${index}`"
            :isError="!!importer.emailError"
            v-model:value="importer.email"
          />
          <p v-if="importer.emailError" class="error-text">
            {{ importer.emailError }}
          </p>
        </div>
        <DropdownSelectable
          label="Menşei"
          :key="`importer-origin-${index}-${importer.origin}-${originOptionsVersion}`"
          :id="`importer-origin-${index}`"
          :dropItems="manufacturerOrigins"
          :isRadioGroup="true"
          :isShowSearch="false"
          :preSelectedRadioItem="
            manufacturerOrigins.find((o) => String(o.id) === String(importer.origin))
          "
          :errorText="importer.originError"
          @selectedRadioItem="
            (value) => handleOriginChange(value, index, 'importer')
          "
        />
      </div>
      <a
        v-if="importers.length < 5"
        @click="addImporter"
        class="manufacturer-business-area-button"
      >
        <img src="@/assets/images/icons/plus-magenta.svg" />
        <p>Farklı İthalatçı / İktisadi İşletmeci Ekle</p>
      </a>
      <p v-else class="limit-text">
        En fazla 5 İthalatçı / İktisadi İşletmeci ekleyebilirsiniz.
      </p>
    </div>
  </div>
</template>

<script setup>
import { Input, DropdownSelectable, Icons } from "@n11/so-ui-components";
import { useStore } from "vuex";
import { ref, onMounted, watch } from "vue";

const store = useStore();

const manufacturerOrigins = ref([]);
const originOptionsVersion = ref(0);

const manufacturers = ref([
  {
    tradeName: "",
    brand: "",
    address: "",
    email: "",
    origin: "",
    tradeNameError: "",
    brandError: "",
    addressError: "",
    emailError: "",
    originError: "",
  },
]);

const importers = ref([
  {
    tradeName: "",
    brand: "",
    address: "",
    email: "",
    origin: "",
    tradeNameError: "",
    brandError: "",
    addressError: "",
    emailError: "",
    originError: "",
  },
]);

const getManufacturerOriginInfo = async () => {
  try {
    const response = await store.dispatch("products/getManufacturerOriginInfo");
    manufacturerOrigins.value = response.data.map((item) => ({
      id: item.value,
      name: `${item.code} - ${item.label}`,
    }));
    originOptionsVersion.value += 1;
  } catch (error) {
    return error;
  }
};

const handleOriginChange = (value, index, type) => {
  const selectedId =
    typeof value === "object" && value !== null
      ? value.id ?? value.value ?? ""
      : value;

  if (type === "manufacturer") {
    manufacturers.value[index].origin = selectedId;
    manufacturers.value[index].originError = "";
  } else {
    importers.value[index].origin = selectedId;
    importers.value[index].originError = "";
  }
};

const hasAnyFieldFilled = (e) =>
  !!(e.tradeName || e.brand || e.address || e.email || e.origin);

const normalizeOriginId = (provider) => {
  const raw =
    provider?.originId ??
    provider?.origin?.id ??
    provider?.origin?.value ??
    provider?.origin ??
    "";
  return raw === null || raw === undefined ? "" : String(raw);
};

const toFormRow = (provider) => ({
  tradeName: provider?.name || provider?.tradeName || "",
  brand: provider?.brand || "",
  address: provider?.address || "",
  email: provider?.email || "",
  origin: normalizeOriginId(provider),
  tradeNameError: "",
  brandError: "",
  addressError: "",
  emailError: "",
  originError: "",
});

const loadTemplateData = (providers = []) => {
  if (!Array.isArray(providers)) return;

  const manufacturerRows = providers
    .filter((p) => p?.type === "MANUFACTURER")
    .map(toFormRow);
  const importerRows = providers
    .filter((p) => p?.type === "IMPORTER")
    .map(toFormRow);

  if (manufacturerRows.length > 0) {
    manufacturers.value = manufacturerRows;
  }
  if (importerRows.length > 0) {
    importers.value = importerRows;
  }
};

const checkManufacturerError = (index) => {
  const manufacturer = manufacturers.value[index];

  if (!hasAnyFieldFilled(manufacturer)) {
    manufacturer.tradeNameError = "";
    manufacturer.addressError = "";
    manufacturer.emailError = "";
    manufacturer.originError = "";
    manufacturer.brandError = "";
    return;
  }

  if (!manufacturer.tradeName) {
    manufacturer.tradeNameError = "Kayıtlı ticari ünvan girmelisiniz.";
  } else {
    manufacturer.tradeNameError = "";
  }

  manufacturer.brandError = "";

  if (!manufacturer.address) {
    manufacturer.addressError = "Adres girmelisiniz.";
  } else {
    manufacturer.addressError = "";
  }

  if (!manufacturer.email) {
    manufacturer.emailError = "E-posta girmelisiniz.";
  } else if (!isValidEmail(manufacturer.email)) {
    manufacturer.emailError =
      "Lütfen e-posta bilgisini formata uygun yazın. (Örn: isim@örnek.com)";
  } else {
    manufacturer.emailError = "";
  }

  if (!manufacturer.origin || manufacturer.origin === "") {
    manufacturer.originError = "Menşei seçmelisiniz.";
  } else {
    manufacturer.originError = "";
  }
};

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const checkImporterError = (index) => {
  const importer = importers.value[index];

  if (!hasAnyFieldFilled(importer)) {
    importer.tradeNameError = "";
    importer.addressError = "";
    importer.emailError = "";
    importer.originError = "";
    importer.brandError = "";
    return;
  }

  if (!importer.tradeName) {
    importer.tradeNameError = "Kayıtlı ticari ünvan girmelisiniz.";
  } else {
    importer.tradeNameError = "";
  }

  importer.brandError = "";

  if (!importer.address) {
    importer.addressError = "İletişim kurulabilecek adres girmelisiniz.";
  } else {
    importer.addressError = "";
  }

  if (!importer.email) {
    importer.emailError = "E-posta girmelisiniz.";
  } else if (!isValidEmail(importer.email)) {
    importer.emailError =
      "Lütfen e-posta bilgisini formata uygun yazın. (Örn: isim@örnek.com)";
  } else {
    importer.emailError = "";
  }

  if (!importer.origin || importer.origin === "") {
    importer.originError = "Menşei seçmelisiniz.";
  } else {
    importer.originError = "";
  }
};

watch(
  manufacturers,
  (list) => {
    list.forEach((_, idx) => checkManufacturerError(idx));
  },
  { deep: true }
);

watch(
  importers,
  (list) => {
    list.forEach((_, idx) => checkImporterError(idx));
  },
  { deep: true }
);

const getManufacturerInfo = () => {
  let allValid = true;

  manufacturers.value.forEach((_, index) => {
    checkManufacturerError(index);
    const m = manufacturers.value[index];
    const hasErrors =
      m.tradeNameError || m.addressError || m.emailError || m.originError;
    if (hasErrors) allValid = false;
  });

  importers.value.forEach((_, index) => {
    checkImporterError(index);
    const i = importers.value[index];
    const hasErrors =
      i.tradeNameError || i.addressError || i.emailError || i.originError;
    if (hasErrors) allValid = false;
  });

  const businessEntities = [];
  manufacturers.value.forEach((m) => {
    if (m.tradeName || m.brand || m.address || m.email || m.origin) {
      businessEntities.push({
        type: "MANUFACTURER",
        name: m.tradeName,
        brand: m.brand,
        address: m.address,
        email: m.email,
        originId:
          typeof m.origin === "object" && m.origin !== null
            ? m.origin.id ?? m.origin.value ?? null
            : m.origin,
      });
    }
  });
  importers.value.forEach((i) => {
    if (i.tradeName || i.brand || i.address || i.email || i.origin) {
      businessEntities.push({
        type: "IMPORTER",
        name: i.tradeName,
        brand: i.brand,
        address: i.address,
        email: i.email,
        originId:
          typeof i.origin === "object" && i.origin !== null
            ? i.origin.id ?? i.origin.value ?? null
            : i.origin,
      });
    }
  });

  return {
    data: businessEntities,
    isValid: allValid,
  };
};

const addManufacturer = () => {
  if (manufacturers.value.length < 5) {
    manufacturers.value.push({
      tradeName: "",
      brand: "",
      address: "",
      email: "",
      origin: "",
      tradeNameError: "",
      brandError: "",
      addressError: "",
      emailError: "",
      originError: "",
    });
  }
};

const addImporter = () => {
  if (importers.value.length < 5) {
    importers.value.push({
      tradeName: "",
      brand: "",
      address: "",
      email: "",
      origin: "",
      tradeNameError: "",
      brandError: "",
      addressError: "",
      emailError: "",
      originError: "",
    });
  }
};

const removeManufacturer = (index) => {
  if (manufacturers.value.length > 1) {
    manufacturers.value.splice(index, 1);
  }
};

const removeImporter = (index) => {
  if (importers.value.length > 1) {
    importers.value.splice(index, 1);
  }
};

onMounted(async () => {
  await getManufacturerOriginInfo();
});

defineExpose({
  getManufacturerInfo,
  loadTemplateData,
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.manufacturer-business-area {
  display: flex;
  justify-content: space-around;
  margin: 24px 0px;

  &-button {
    display: flex;
    gap: 8px;
    color: $colorM50;
    cursor: pointer;

    p {
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
    }
  }
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.box {
  flex: 1;

  &:last-child {
    margin-left: 25px;
  }
  .box-form-area {
    textarea {
      color: $colorN80;
      border: 1px solid $colorD30;

      &::placeholder {
        font-size: 12px;
        line-height: 18px;
        color: #4e5c78;
      }
    }
  }
  .title-area {
    .title {
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      margin-bottom: 8px;
    }

    .description {
      font-size: 11px;
      line-height: 14px;
      height: 30px;
    }
  }
  &-form-area {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 16px 0px;
  }
}

.limit-text,
.error-text {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: $colorE50;
  margin-left: 12px;
}
.remove-button-content {
  display: flex;
  justify-content: right;
  gap: 4px;
  color: $colorM50;

  img {
    width: 16px;
    height: 16px;
  }

  .span {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: $colorM50;
    align-self: flex-end;
  }
}
</style>
